webpackJsonp([112254247690605],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';  \n  & > ul, .chapterItems {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  p, h6 {\n    display: inline-block;\n    font-weight: 200;\n    margin: 0;\n  }\n  \n  .tocHeading {\n     font-weight: 200;\n     color: ', ';\n     margin-bottom: 10px;\n  }\n'], ['\n  padding: ', ';  \n  & > ul, .chapterItems {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  p, h6 {\n    display: inline-block;\n    font-weight: 200;\n    margin: 0;\n  }\n  \n  .tocHeading {\n     font-weight: 200;\n     color: ', ';\n     margin-bottom: 10px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  h6, p {\n    color: black;\n    margin: 0;\n    line-height: 1.5;\n  }\n  li {\n    margin: 0;\n  }\n  &:hover {\n    li {\n      span {\n        border-bottom: 1px solid black;\n      }\n    }\n  }\n'], ['\n  h6, p {\n    color: black;\n    margin: 0;\n    line-height: 1.5;\n  }\n  li {\n    margin: 0;\n  }\n  &:hover {\n    li {\n      span {\n        border-bottom: 1px solid black;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This class should not be used for listing posts, but for chapter based Docs. See PostListing for that.
	// You'll also need to add your chapters to siteConfig
	
	var TableOfContents = function (_React$Component) {
	  _inherits(TableOfContents, _React$Component);
	
	  function TableOfContents() {
	    _classCallCheck(this, TableOfContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TableOfContents.prototype.buildNodes = function buildNodes() {
	    var _props = this.props,
	        posts = _props.posts,
	        language = _props.language;
	
	    language = language.toLowerCase();
	    var type = this.props.contentsType;
	    var postNodes = [];
	    posts.forEach(function (post) {
	      if (post.node.frontmatter.type === type) {
	        var postNode = {
	          title: post.node.frontmatter.title,
	          path: '/' + language + '/' + type + '/' + post.node.frontmatter.programming_language + post.node.fields.slug,
	          programming_language: post.node.frontmatter.programming_language,
	          lessonNumber: post.node.frontmatter.lesson,
	          chapter: post.node.frontmatter.chapter
	        };
	        postNodes.push(postNode);
	      }
	    });
	
	    var postNodeChapters = [];
	    postNodes.forEach(function (post) {
	      if (postNodeChapters[post.chapter]) {
	        postNodeChapters[post.chapter].push(post);
	      } else {
	        postNodeChapters[post.chapter] = [post];
	      }
	    });
	
	    postNodeChapters.forEach(function (chapter) {
	      chapter.sort(function (a, b) {
	        return a.lessonNumber - b.lessonNumber;
	      });
	    });
	    return postNodeChapters;
	  };
	
	  TableOfContents.prototype.nodeListItems = function nodeListItems() {
	    var _this2 = this;
	
	    var postNodeChapters = this.buildNodes();
	    var listItems = [];
	    var chapterTitles = this.props.chapterTitles;
	    postNodeChapters.forEach(function (chapter, idx) {
	      var chapterLessons = [];
	      chapter.forEach(function (node, nodeIdx) {
	        chapterLessons.push(_react2.default.createElement(
	          LessonContainer,
	          { key: 'lesson-' + nodeIdx },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: node.path },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  node.chapter,
	                  '.',
	                  node.lessonNumber,
	                  ' \xA0'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  node.title
	                )
	              )
	            )
	          )
	        ));
	      });
	      listItems.push(_react2.default.createElement(
	        'li',
	        { className: 'chapter', key: idx },
	        _react2.default.createElement(
	          'h5',
	          { className: 'tocHeading' },
	          chapterTitles[_this2.props.language.toLowerCase()][idx]
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'chapterItems' },
	          chapterLessons
	        )
	      ));
	    });
	    return listItems;
	  };
	
	  TableOfContents.prototype.render = function render() {
	    return _react2.default.createElement(
	      TableOfContentsContainer,
	      null,
	      _react2.default.createElement(
	        'ul',
	        null,
	        this.nodeListItems()
	      )
	    );
	  };
	
	  return TableOfContents;
	}(_react2.default.Component);
	
	var TableOfContentsContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.brand;
	});
	
	var LessonContainer = _styledComponents2.default.div(_templateObject2);
	
	exports.default = TableOfContents;
	module.exports = exports['default'];

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO,
	        language = _props.language;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      postURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix + postPath;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === '/' ? '' : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      '@context': 'http://schema.org',
	      '@type': 'WebSite',
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt[language] : ''
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            '@id': postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        '@context': 'http://schema.org',
	        '@type': 'BlogPosting',
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt['en_uk'] : '',
	        headline: title,
	        image: {
	          '@type': 'ImageObject',
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', {
	        property: 'fb:app_id',
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', {
	        name: 'twitter:creator',
	        content: _SiteConfig2.default.userTwitter ? _SiteConfig2.default.userTwitter : ''
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['  \n  width: 100vw;\n  display: grid;  \n  grid-template-areas: \n    "header"\n    "content"\n    "nav";    \n      \n  @media (min-width: ', ') {\n    height: 100vh;\n    grid-template-columns: 300px 1fr;\n    grid-template-rows: 75px 1fr;\n    grid-template-areas: \n      "header  header"      \n      "nav content";\n    #nav {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n'], ['  \n  width: 100vw;\n  display: grid;  \n  grid-template-areas: \n    "header"\n    "content"\n    "nav";    \n      \n  @media (min-width: ', ') {\n    height: 100vh;\n    grid-template-columns: 300px 1fr;\n    grid-template-rows: 75px 1fr;\n    grid-template-areas: \n      "header  header"      \n      "nav content";\n    #nav {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  grid-area: content;  \n  justify-self: center;  \n  width: 100%;     \n  padding: ', ';\n  padding-bottom: 0;\n  padding-top: 0;\n  & > article {\n    max-width: ', ';\n    margin: auto;\n  }  \n  & > h1 {\n    color: ', ';\n  }\n  @media (max-width: ', ') {\n    max-width: 95vw;\n  }\n  @media (min-width: ', ') {\n    overflow: scroll;\n    padding-bottom: ', ';\n  }\n'], ['\n  grid-area: content;  \n  justify-self: center;  \n  width: 100%;     \n  padding: ', ';\n  padding-bottom: 0;\n  padding-top: 0;\n  & > article {\n    max-width: ', ';\n    margin: auto;\n  }  \n  & > h1 {\n    color: ', ';\n  }\n  @media (max-width: ', ') {\n    max-width: 95vw;\n  }\n  @media (min-width: ', ') {\n    overflow: scroll;\n    padding-bottom: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  grid-area: header;\n  width: 100%;  \n  z-index: 2;\n'], ['\n  grid-area: header;\n  width: 100%;  \n  z-index: 2;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  grid-area: nav;\n  padding-top: 0\n  @media (min-width: ', ') {\n    overflow: scroll;\n    padding-top: ', ';\n  }  \n'], ['\n  grid-area: nav;\n  padding-top: 0\n  @media (min-width: ', ') {\n    overflow: scroll;\n    padding-top: ', ';\n  }  \n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(14);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _SEO = __webpack_require__(48);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _TableOfContents = __webpack_require__(225);
	
	var _TableOfContents2 = _interopRequireDefault(_TableOfContents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LessonTemplate = function (_React$Component) {
	  _inherits(LessonTemplate, _React$Component);
	
	  function LessonTemplate() {
	    _classCallCheck(this, LessonTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LessonTemplate.prototype.render = function render() {
	    var _props$pathContext = this.props.pathContext,
	        slug = _props$pathContext.slug,
	        language = _props$pathContext.language;
	
	
	    var postNode = this.props.data.postBySlug;
	    var post = postNode.frontmatter;
	    if (!post.id) {
	      post.id = slug;
	    }
	    if (!post.id) {
	      post.category_id = _SiteConfig2.default.postDefaultCategoryID;
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          post.title + ' | ' + _SiteConfig2.default.siteTitle
	        )
	      ),
	      _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	      _react2.default.createElement(
	        BodyGrid,
	        null,
	        _react2.default.createElement(
	          HeaderContainer,
	          { className: 'header' },
	          _react2.default.createElement(_Header2.default, { location: this.props.location, language: language })
	        ),
	        _react2.default.createElement(
	          BodyContainer,
	          { className: 'content' },
	          _react2.default.createElement(
	            'article',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              post.title
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: postNode.html } })
	          )
	        ),
	        _react2.default.createElement(
	          ToCContainer,
	          { className: 'nav' },
	          _react2.default.createElement(_TableOfContents2.default, {
	            posts: this.props.data.allPostTitles.edges,
	            contentsType: 'lesson',
	            language: language,
	            chapterTitles: _SiteConfig2.default.toCChapters
	          })
	        )
	      )
	    );
	  };
	
	  return LessonTemplate;
	}(_react2.default.Component);
	
	exports.default = LessonTemplate;
	
	
	var BodyGrid = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.widthLaptop;
	});
	
	var BodyContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.theme.sitePadding;
	}, function (props) {
	  return props.theme.contentWidthLaptop;
	}, function (props) {
	  return props.theme.accentDark;
	}, function (props) {
	  return props.theme.widthLaptop;
	}, function (props) {
	  return props.theme.widthLaptop;
	}, function (props) {
	  return props.theme.sitePadding;
	});
	
	var HeaderContainer = _styledComponents2.default.div(_templateObject3);
	
	var ToCContainer = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.widthLaptop;
	}, function (props) {
	  return props.theme.sitePadding;
	});
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-lesson-jsx-fdd6150f96e24d14450b.js